export const SHORT_DESC =
  "Gospel Truth AI saves you up to twenty hours of research for every sermon, personal devotional or Bible study you create";
export const SHORT_PLACE_HOLDER =
  "When you are inspired you are more productive to Saves you hours of research.";
export const TIME_INTERVAL_TYPEWRITER = 4; //miliseconds
export const CHAT_TYPE = {
  PRIVATE: "private",
  PUBLIC: "public",
  PRIVATE_V2: "private_v2",
  PUBLIC_O3: "public_O3",
  PRIVATE_O3: "private_O3",
  PRIVATE_V3_2: "private_v3_2",
  PUBLIC_V3_2: "public_v3_2",
  UPGRADE: "upgrade",
  DEEPSEEK: "deepseek",
  DEEPSEEK_V3_PUBLIC: "deepseek_v3_public",
  DEEPSEEK_V3_PRIVATE: "deepseek_v3_private",
  GPT_PRIVATE: "gpt_private",
  GPT_PUBLIC: "gpt_public",
  GEMINI_BETA_PUBLIC: "gemini_beta_public",
  GEMINI_BETA_PRIVATE: "gemini_beta_private",
  ELASTIK_POC: "elastik_poc",
};

export const SEARCH_TYPE_OPTIONS = [
  { id: CHAT_TYPE.PRIVATE, gospel: "Gospel", truth: "Truth", suffix: "Private" },
  { id: CHAT_TYPE.PUBLIC, gospel: "Gospel", truth: "Truth", suffix: "Public" },
  {
    id: CHAT_TYPE.PRIVATE_V2,
    gospel: "Gospel",
    truth: "Truth",
    suffix: "Private 2.0",
  },
];

export const USER_ROLES_CREATE_FORM = [
  {
    id: "gold",
    value: "Gold",
  },
  {
    id: "user",
    value: "Normal",
  },
];

export const ROLE = {
  ADMIN: "admin",
  USER: "user",
  GOLD: "gold",
};

export const SUBSCRIPTION_TYPE = {
  CHAT: "chat_subscription",
  CUSTOM_VOICE: "voice_subscription",
};

export const PLAN_STATUS = {
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE",
};

export const TRANS_TYPE = {
  MORE_CHAT: 0,
  MORE_VOICE: 1,
};

export const COUPON_STATUS = {
  active: "active",
  used: "used",
  expired: "expired",
  inactive: "inactive",
};
